<div class="row">
    <div class="banner-container" style="margin-right: 0px; margin-left: 0px">
        <img src="assets/images/banner2.776a5913.jpg" width="100%" height="10%">
    </div>
    <mat-drawer-container class="page-container">
        <mat-drawer class="sidenav-container" mode="side" opened>
            <app-sidemenu [items]="menuItems" [icons]="false" (changeContent)="loadContent($event)"></app-sidemenu>
        </mat-drawer>
        <mat-drawer-content>
            <mat-card class="welcome-card">
                <mat-card-header>
                    <mat-card-title>
                        <h2>{{contentTitle}}</h2>
                        <hr>
                        <button *ngIf="contentTitle" (click)="login()" mat-fab extended class="login-button" matTooltip="Accesso riservato agli utenti abilitati al servizio QRSP">
                            <mat-icon>lock_open</mat-icon>
                            <span class="login-button-text">Accedi ad area riservata</span>
                        </button>
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content [ngSwitch]="contentId">
                    <div class="main-content">
                        <app-home-page *ngSwitchCase="1"></app-home-page>
                        <app-ricerca-profili-competenze *ngSwitchCase="2"></app-ricerca-profili-competenze>
                        <app-standard-professionali *ngSwitchCase="3"></app-standard-professionali>
                        <app-certificazione-competenze *ngSwitchCase="4"></app-certificazione-competenze>
                        <app-norma-riferimento *ngSwitchCase="5"></app-norma-riferimento>
                        <app-decreti-approvazione *ngSwitchCase="6"></app-decreti-approvazione>
                        <app-figure *ngSwitchCase="7"></app-figure>
                        <app-percorsi *ngSwitchCase="8"></app-percorsi>
                        <app-attori *ngSwitchCase="9"></app-attori>
                        <app-glossario *ngSwitchCase="10"></app-glossario>
                        <app-faq *ngSwitchCase="11"></app-faq>
                    </div>
                </mat-card-content>
            </mat-card>

        </mat-drawer-content>
    </mat-drawer-container>

</div>
